import { createContext, useContext } from 'react';
import type { AppLocale } from './locale-storage';

/**
 * El idioma del usuario en la rama de `fsd/`. Las páginas que solo necesitan el idioma lo leen de
 * `useLingui().i18n.locale`, que ya lo refleja. La zona horaria y los formatos de número y fecha
 * se leen con `useRegion()` de `@fsd/shared/config/region`.
 */
export interface UserLocale {
  /** La última elección; mientras su catálogo carga puede adelantarse a `i18n.locale`. */
  locale: AppLocale;
  /** `null` mientras la query de preferencias no llegó. */
  userId: number | null;
  /**
   * Activa el idioma y, cuando quedó activo, lo guarda y lo persiste en el servidor. Si el catálogo no
   * carga o el servidor falla, vuelve al anterior y avisa.
   */
  setLocale: (next: AppLocale) => Promise<void>;
  /** La última elección no se pudo aplicar o guardar en el servidor (y se revirtió). */
  saveFailed: boolean;
}

// Contexto y hook en un `.ts` aparte del provider por `react-refresh/only-export-components`.
export const UserLocaleContext = createContext<UserLocale | null>(null);

export function useUserLocale(): UserLocale {
  const value = useContext(UserLocaleContext);
  if (!value) throw new Error('useUserLocale necesita un UserLocaleProvider');
  return value;
}
